module.exports = __webpack_public_path__ + "img/15-min.d545f1f6.jpg";